import React, { createContext, useContext, useState, useCallback, useRef } from 'react';
import WatrlyDialog from '../components/WatrlyDialog';

const DialogContext = createContext(null);

export const DialogProvider = ({ children }) => {
  const [state, setState] = useState(null);
  const resolveRef = useRef(null);

  const confirm = useCallback(({
    title       = 'تأكيد',
    message     = '',
    type        = 'confirm',
    confirmText = 'تأكيد',
    cancelText  = 'إلغاء',
  } = {}) => {
    return new Promise((resolve) => {
      resolveRef.current = resolve;
      setState({ title, message, type, confirmText, cancelText });
    });
  }, []);

  const handleConfirm = () => {
    setState(null);
    resolveRef.current?.(true);
  };

  const handleCancel = () => {
    setState(null);
    resolveRef.current?.(false);
  };

  return (
    <DialogContext.Provider value={{ confirm }}>
      {children}
      {state && (
        <WatrlyDialog
          {...state}
          onConfirm={handleConfirm}
          onCancel={handleCancel}
        />
      )}
    </DialogContext.Provider>
  );
};

export const useDialog = () => {
  const ctx = useContext(DialogContext);
  if (!ctx) throw new Error('useDialog must be used within DialogProvider');
  return ctx;
};
